export default () => {
  const exprColNum = /^-?\d{8,9}$/;
  const collegiateNumber =
    window.localStorage.getItem('auth_ehealth') &&
    JSON.parse(window.localStorage.getItem('auth_ehealth'))['collegiateNumber'];

  return typeof collegiateNumber !== 'undefined' && exprColNum.test(collegiateNumber);
};
